import { dateFormatter, dateTimeFormatter } from "@/services/Grid/Formatters";
import { dateComparator } from "@/services/Grid/Comparators";

export const columnTypes =
    {
      dateColumn: {
        filter: 'agDateColumnFilter',
        valueFormatter: data => dateFormatter(data),
        filterParams: {
          comparator:
              (filterLocalDateAtMidnight, cellValue) =>
                  dateComparator(filterLocalDateAtMidnight, cellValue),
          suppressAndOrCondition: true,
        },
      },
      dateTimeColumn: {
        filter: 'agDateColumnFilter',
        valueFormatter: data => dateTimeFormatter(data),
        filterParams: {
          comparator:
              (filterLocalDateAtMidnight, cellValue) =>
                  dateComparator(filterLocalDateAtMidnight, cellValue),
          suppressAndOrCondition: true,
        },
      },
    };
